import { createSlice } from '@reduxjs/toolkit';
import {
    createProfile,
    getAllRequestsAct,
    getMyRequestsAct,
    getRequestById,
    getSpotCreditRequest,
} from '../actions/requestApi';

export const requestManageSlice = createSlice({
    name: 'requestManageMent',
    initialState: {
        isLoading: false,
        allRequestList: [],
        nextPageDetailAllRequest: {},
        prevPageDetailAllRequest: [],
        count: null,
        myRequestsList: [],
        myRequestCount: null,
        requestULID: '',
        updateProfiletimestamp: '',
        requestById: null,
        spotCreditRequest: [],
        allRequestsPaginationDetails: null,
        myRequestsListPaginationDetails: null,
        isUpdatingProfile: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllRequestsAct.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAllRequestsAct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allRequestList = action.payload?.requests;
                state.allRequestsPaginationDetails = action.payload?.paginationDetails;
                state.count = action.payload.count;
            })
            .addCase(getAllRequestsAct.rejected, (state, action) => {
                state.isLoading = false;
                state.allRequestList = [];
            })
            .addCase(getMyRequestsAct.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getMyRequestsAct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.myRequestsList = action.payload?.requests;
                state.myRequestCount = action.payload.count;
                state.myRequestsListPaginationDetails = action.payload.paginationDetails;
            })
            .addCase(getMyRequestsAct.rejected, (state, action) => {
                state.isLoading = false;
                state.allRequestList = [];
            })
            .addCase(createProfile.pending, (state, action) => {
                state.isUpdatingProfile = true;
            })
            .addCase(createProfile.fulfilled, (state, action) => {
                state.isUpdatingProfile = false;
                state.requestULID = action.payload.requestULID;
                state.updateProfiletimestamp = action.payload.timestamp;
            })
            .addCase(createProfile.rejected, (state, action) => {
                state.isUpdatingProfile = false;
            })
            .addCase(getRequestById.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getRequestById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.requestById = action.payload.payload;
            })
            .addCase(getRequestById.rejected, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getSpotCreditRequest.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getSpotCreditRequest.fulfilled, (state, action) => {
                state.spotCreditRequest = action.payload;
            })
            .addCase(getSpotCreditRequest.rejected, (state, action) => {
                state.isLoading = false;
            });
    },
});

export default requestManageSlice.reducer;
